import React from 'react';
import { Alert } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { ConditionalRender } from '../formControls';

const CodingEventAttachedAlert = (props) => {

    return (
        <ConditionalRender visible={props.codingEventId > 0}>
            <Alert variant="success" className="mb-0 pl-3 pr-3 pt-2 pb-2">
                <small>
                    <b>This message has an attached coding event. </b>
                    <LinkContainer to={props.codingEventUri + props.codingEventId}>
                        <Alert.Link>Click here</Alert.Link>
                    </LinkContainer> to view the event.</small>
            </Alert>
        </ConditionalRender>
    )
}

export default CodingEventAttachedAlert;